import { useQueryClient } from "@tanstack/react-query";
import * as Notifications from "expo-notifications";
import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@/hooks/application/store";
import { NOTIFICATIONS_QUERY_KEY } from "@/hooks/domain/clientNotifications";
import { Address } from "@/interfaces/domain/Address";
import { SET_ADDRESS } from "@/store/ducks/checkout";
import { isNativeDevice } from "@/utils/platform";

export const AppBoundary = ({ children }) => {
  const { user } = useAppSelector((store) => store.auth);
  const address = useAppSelector((store) => store.checkout.address);
  const queryClient = useQueryClient();

  const dispatch = useAppDispatch();

  const setDeliveryAddress = (address: Address) => {
    dispatch(SET_ADDRESS(address));
  };

  useEffect(() => {
    const userAddress = user?.cliente?.endereco_principal;
    if (!address && userAddress) {
      setDeliveryAddress(userAddress);
    }
  }, []);

  useEffect(() => {
    if (isNativeDevice) {
      const subscriber = Notifications.addNotificationReceivedListener(() => {
        queryClient.refetchQueries(NOTIFICATIONS_QUERY_KEY);
      });
      return () => subscriber.remove();
    }
  }, []);

  return <>{children}</>;
};
